export default {
    path: "/project",
    name: "project",
    meta: {
        icon: "md-bookmarks",
        access: "menu_project",
        title: "项目管理",
    },
    component: () => import("@/views/Main.vue"),
    children: [
        {
            path: "project-list",
            name: "project-list",
            meta: {
                icon: "md-people",
                access: "menu_project_list",
                title: "项目管理",
            },
            component: () => import("@/views/project/list.vue"),
        },
    ],
};
